import PopupResult from '@r1-frontend/ui-react/components/popups/popupResult';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { flushState } from '~/src/entities/speed-bonus/context/actions';
import { useContextDispatch, useContextSelector } from '~/src/entities/speed-bonus/context/hooks';

import ResultFooter from './Footer';

const ResultPopup = (): JSX.Element | null => {
    const ctxDispatch = useContextDispatch();

    const { entity, status, header, message, target } = useContextSelector(state => state.result);

    if (target !== 'popup' || status === 'none') {
        return null;
    }

    const onClose = () => {
        ctxDispatch(flushState());
    };

    return (
        <PopupResult isOpen={true} type={status} onClose={onClose}>
            <FullWidthListContainer $direction={'column'} $desktop={24} $mobile={16}>
                <TextWrapper $lastIndent={false}>
                    <H3 dangerouslySetInnerHTML={{ __html: header }}/>
                    {message && (
                        <Paragraph4 $color={COLORS.TextInfo} dangerouslySetInnerHTML={{ __html: message }}/>
                    )}
                </TextWrapper>

                <ResultFooter entity={entity} status={status}/>
            </FullWidthListContainer>
        </PopupResult>
    );
};

export default ResultPopup;
